import React, { useReducer, useState } from 'react'
import BirthControlTestContext from '../context/BirthControlTestContext'
import { get, post } from 'aws-amplify/api'

const BirthControlTestProvider = ({ children }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL
  const initialFormState = {
    organized: null,
    childrenPlanning: null,
    acceptsHormones: null,
    menstrualPeriod: null,
    smokes: null,
    cigarettesQty: null,
    age: null,
    diseases: null,
    weight: undefined,
    height: undefined,
    medicalRecord: null
  }

  const formReducer = (state, action) => {
    const stateToReturn = { ...state }

    switch (action.type) {
      case 'organized':
        stateToReturn.organized = action.payload
        break
      case 'childrenPlanning':
        stateToReturn.childrenPlanning = action.payload
        break
      case 'efficiency':
        stateToReturn.efficiency = action.payload
        break
      case 'acceptsHormones':
        stateToReturn.acceptsHormones = action.payload
        break
      case 'menstrualPeriod':
        stateToReturn.menstrualPeriod = action.payload
        break
      case 'smokes':
        stateToReturn.cigarettesQty = action.payload.cigarettesQty
        stateToReturn.smokes = action.payload.smokes
        break
      case 'age':
        stateToReturn.age = action.payload
        break
      case 'diseases':
        stateToReturn.diseases = action.payload
        break
      case 'weight':
        stateToReturn.weight = action.payload
        break
      case 'height':
        stateToReturn.height = action.payload
        break
      case 'medicalRecord':
        stateToReturn.medicalRecord = action.payload
        break
      default:
        break
    }
    return stateToReturn
  }
  const stepReducer = (state, action) => {
    switch (action.type) {
      case 'forward':
        return state + 1
      case 'backward':
        return state - 1
      default:
        break
    }
  }

  const [formStep, setStep] = useReducer(stepReducer, 0)
  const [formToSend, setFormState] = useReducer(formReducer, initialFormState)
  const [userState, setUserState] = useState({})

  const PostSendForm = async (body) => {
    try {
      const resp = post({
        apiName: baseUrl,
        path: '/health/birthControlTest',
        options: {
          headers: {
            'content-type': 'application/json'
          },
          body
        }
      })
      const { body: responseBody } = await resp.response
      const data = await responseBody.json()
      return data
    } catch (error) {
      return error
    }
  }

  const getPhoneCodes = async () => {
    try {
      const resp = get({
        apiName: baseUrl,
        path: '/getCountryPhoneCodes'
      })
      const { body } = await resp.response
      const data = await body.json()
      return data.data
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <BirthControlTestContext.Provider
      value={{
        PostSendForm,
        formStep,
        setStep,
        formToSend,
        setFormState,
        userState,
        setUserState,
        getPhoneCodes
      }}
    >
      {children}
    </BirthControlTestContext.Provider>
  )
}

export default BirthControlTestProvider
